// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3Yx95","footer":"ChangeClinic_footer__2-TP5"};